
import React from 'react';

const GooglePlay = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='124.62'
			height='36'
			fill='none'
			viewBox='0 0 180 52'
		>
			<path
				fill='#fff'
				d='M90.722 20.977c-3.128 0-5.682 2.324-5.682 5.53 0 3.18 2.554 5.529 5.682 5.529 3.134 0 5.689-2.349 5.689-5.529 0-3.206-2.555-5.53-5.69-5.53zm0 8.881c-1.716 0-3.192-1.383-3.192-3.35 0-1.994 1.476-3.353 3.192-3.353 1.716 0 3.199 1.358 3.199 3.352 0 1.968-1.483 3.351-3.2 3.351zm-12.398-8.88c-3.134 0-5.682 2.323-5.682 5.53 0 3.18 2.548 5.528 5.682 5.528 3.132 0 5.682-2.349 5.682-5.529 0-3.206-2.55-5.53-5.682-5.53zm0 8.88c-1.718 0-3.2-1.383-3.2-3.35 0-1.994 1.482-3.353 3.2-3.353 1.716 0 3.192 1.358 3.192 3.352 0 1.968-1.476 3.351-3.192 3.351zM63.57 22.672v2.35h5.747c-.168 1.313-.618 2.278-1.307 2.951-.838.813-2.145 1.715-4.44 1.715-3.537 0-6.306-2.787-6.306-6.24 0-3.454 2.769-6.24 6.306-6.24 1.912 0 3.304.73 4.33 1.675l1.697-1.656c-1.437-1.339-3.347-2.368-6.027-2.368-4.85 0-8.926 3.853-8.926 8.589 0 4.735 4.076 8.588 8.926 8.588 2.621 0 4.59-.839 6.138-2.412 1.586-1.548 2.08-3.726 2.08-5.484 0-.546-.046-1.048-.13-1.468h-8.088zm60.327 1.822c-.468-1.237-1.911-3.517-4.85-3.517-2.913 0-5.338 2.241-5.338 5.53 0 3.098 2.4 5.529 5.617 5.529a5.647 5.647 0 004.721-2.45l-1.931-1.257c-.644.92-1.521 1.53-2.79 1.53-1.26 0-2.163-.565-2.743-1.676l7.575-3.06-.261-.629zm-7.723 1.841a3.067 3.067 0 012.958-3.224c.988 0 1.827.483 2.107 1.173l-5.065 2.051zm-6.156 5.364h2.489V15.45h-2.489V31.7zm-4.078-9.49h-.083c-.56-.646-1.626-1.232-2.978-1.232-2.836 0-5.43 2.431-5.43 5.548 0 3.1 2.594 5.51 5.43 5.51 1.352 0 2.418-.59 2.978-1.255h.083v.793c0 2.114-1.157 3.25-3.023 3.25-1.521 0-2.465-1.073-2.854-1.975l-2.165.883c.624 1.465 2.276 3.269 5.019 3.269 2.92 0 5.383-1.677 5.383-5.757v-9.93h-2.36v.896zm-2.848 7.65c-1.716 0-3.152-1.403-3.152-3.334 0-1.948 1.436-3.37 3.152-3.37 1.691 0 3.024 1.422 3.024 3.37 0 1.93-1.333 3.333-3.024 3.333zm32.462-14.41H129.6V31.7h2.483v-6.157h3.472c2.758 0 5.463-1.948 5.463-5.047 0-3.097-2.712-5.046-5.463-5.046zm.065 7.833h-3.537V17.71h3.537a2.854 2.854 0 012.913 2.785c0 1.258-1.059 2.787-2.913 2.787zm15.35-2.335c-1.794 0-3.659.773-4.427 2.488l2.204.901c.474-.901 1.346-1.194 2.268-1.194 1.289 0 2.595.756 2.615 2.09v.17c-.449-.253-1.411-.629-2.595-.629-2.373 0-4.791 1.276-4.791 3.657 0 2.177 1.944 3.58 4.129 3.58 1.671 0 2.593-.736 3.172-1.593h.085v1.256h2.399V25.44c0-2.881-2.204-4.493-5.059-4.493zm-.299 8.905c-.812 0-1.944-.394-1.944-1.377 0-1.258 1.411-1.74 2.633-1.74 1.093 0 1.606.236 2.27.546-.195 1.505-1.521 2.57-2.959 2.57zm14.095-8.55l-2.854 7.045h-.085l-2.951-7.045h-2.678l4.434 9.845-2.53 5.478h2.595l6.832-15.323h-2.763zM142.382 31.7h2.49V15.45h-2.49V31.7z'
			></path>
			<path
				fill='url(#paint0_linear)'
				d='M13.894 9.8c-.39.4-.617 1.022-.617 1.829v28.749c0 .806.226 1.428.617 1.828l.097.088 16.5-16.104v-.38l-16.5-16.104-.097.094z'
			></path>
			<path
				fill='url(#paint1_linear)'
				d='M35.985 31.56l-5.494-5.37v-.38l5.501-5.37.123.07 6.515 3.618c1.859 1.027 1.859 2.717 0 3.75l-6.515 3.613-.13.07z'
			></path>
			<path
				fill='url(#paint2_linear)'
				d='M36.115 31.49L30.491 26 13.894 42.206c.618.634 1.625.71 2.77.076l19.451-10.791z'
			></path>
			<path
				fill='url(#paint3_linear)'
				d='M36.115 20.51L16.664 9.717c-1.145-.628-2.152-.551-2.77.082L30.491 26l5.624-5.49z'
			></path>
			<defs>
				<linearGradient
					id='paint0_linear'
					x1='29.026'
					x2='7.215'
					y1='40.677'
					y2='18.338'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#00A0FF'></stop>
					<stop offset='0.007' stopColor='#00A1FF'></stop>
					<stop offset='0.26' stopColor='#00BEFF'></stop>
					<stop offset='0.512' stopColor='#00D2FF'></stop>
					<stop offset='0.76' stopColor='#00DFFF'></stop>
					<stop offset='1' stopColor='#00E3FF'></stop>
				</linearGradient>
				<linearGradient
					id='paint1_linear'
					x1='45.05'
					x2='12.832'
					y1='25.998'
					y2='25.998'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#FFE000'></stop>
					<stop offset='0.409' stopColor='#FFBD00'></stop>
					<stop offset='0.775' stopColor='orange'></stop>
					<stop offset='1' stopColor='#FF9C00'></stop>
				</linearGradient>
				<linearGradient
					id='paint2_linear'
					x1='33.057'
					x2='3.48'
					y1='23.015'
					y2='-7.279'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#FF3A44'></stop>
					<stop offset='1' stopColor='#C31162'></stop>
				</linearGradient>
				<linearGradient
					id='paint3_linear'
					x1='9.716'
					x2='22.924'
					y1='51.771'
					y2='38.243'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#32A071'></stop>
					<stop offset='0.069' stopColor='#2DA771'></stop>
					<stop offset='0.476' stopColor='#15CF74'></stop>
					<stop offset='0.801' stopColor='#06E775'></stop>
					<stop offset='1' stopColor='#00F076'></stop>
				</linearGradient>
			</defs>
		</svg>
	);
};

export default GooglePlay;
